import styled from 'styled-components';

export const ProfileToggleContainer = styled.div`
    color: #d97712;
    font-size: 0.875rem;
    padding: 0.25rem;
    margin-top: 0.25rem;
    width: 100%;
`;

export const ToggleContainer = styled.div`
    display: flex;
    width: 100%;
    color: #292929;
    column-gap: 0.75rem;
    align-items: flex-start;
    line-height: 26px;

    /* The switch - the box around the slider */
    .switch {
        position: relative;
        display: inline-block;
        width: 45px;
        height: 26px;
    }

    /* Hide default HTML checkbox */
    .switch input {
        opacity: 0;
        width: 0;
        height: 0;
    }

    /* The slider */
    .slider {
        position: absolute;
        cursor: pointer;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-color: #ccc;
        transition: 0.4s;
    }

    .slider::before {
        position: absolute;
        content: '';
        height: 18px;
        width: 18px;
        left: 4px;
        bottom: 4px;
        background-color: white;
        transition: 0.4s;
    }

    input:checked + .slider {
        background-color: #d97712;
    }

    input:checked + .slider::before {
        transform: translateX(18px);
    }

    /* Rounded sliders */
    .slider.round {
        border-radius: 25px;
    }

    .slider.round::before {
        border-radius: 50%;
    }
`;

export const ToggleTextContainer = styled.div`
    margin-top: 0.5rem;
`;
